import templateUrl from './orgUsage.tpl.html';
import * as Sitemaps from '../../../../app/routing/Sitemaps';
import { userHasAccessToAllEndpoints } from '@splunk/olly-common/RBAC';
import { orgUsageFeaturesEndpointMap } from './orgUsageFeaturesEndpointMap';

angular
    .module('signalview.orgUsage')

    .component('orgUsage', {
        templateUrl,
        bindings: {
            orgId: '<',
            editable: '<',
        },
        controller: [
            '$scope',
            '$location',
            'orgSubscriptionService',
            'organizationService',
            'subscriptionTypeUtil',
            'currentUser',
            'featureEnabled',
            function (
                $scope,
                $location,
                orgSubscriptionService,
                organizationService,
                subscriptionTypeUtil,
                currentUser,
                featureEnabled
            ) {
                const ctrl = this;

                ctrl.$onInit = $onInit;

                ctrl.forbidden = false;

                ctrl.newUsageBillingEnabled = featureEnabled('newUsageBilling');
                ctrl.apm2Enabled = featureEnabled('apm2');
                ctrl.logsEnabled = featureEnabled('logs');
                ctrl.newRbacExperience = featureEnabled('newRbacExperience');
                ctrl.magneticPageHeader = featureEnabled('magneticPageHeader');
                ctrl.headerNavigation = [
                    {
                        id: Sitemaps.OrganizationUsage.map.id,
                        label: Sitemaps.OrganizationUsage.map.label,
                    },
                ];

                function $onInit() {
                    checkCapability();
                    organizationService
                        .get()
                        .then((org) => {
                            ctrl.subscriptionSvc = orgSubscriptionService.get(org);
                            ctrl.accountPromise = ctrl.subscriptionSvc.getAccount();
                            ctrl.nonLegacyOrg = subscriptionTypeUtil.isNonLegacy(
                                org.accountSubscriptionType
                            );
                            ctrl.hostBasedOrg = subscriptionTypeUtil.isHostBased(
                                org.accountSubscriptionType
                            );
                        })
                        .finally(() => {
                            $scope.$applyAsync();
                        });

                    userHasSeenTokenLimit();
                }

                function checkCapability() {
                    currentUser.userCapabilities().then((capabilities) => {
                        ctrl.forbidden = !userHasAccessToAllEndpoints(
                            orgUsageFeaturesEndpointMap.viewIMMUsageTab,
                            capabilities
                        );
                    });
                }

                function userHasSeenTokenLimit() {
                    const userSeenDate = new Date().getTime();
                    currentUser
                        .preferences()
                        .then(function (prefs) {
                            if (prefs) {
                                return currentUser.updatePreferences({
                                    sf_orgBillingPageLastViewed: userSeenDate,
                                    sf_id: prefs.sf_id,
                                });
                            }
                        })
                        .then(() => {
                            $scope.$emit('refresh hazard icon');
                        });
                }
            },
        ],
    });
